import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ImageMosaic, ImageMosaicDto, MosaicWall } from '@ami/react/core';
import { Alert } from 'reactstrap';
import { makeConcealable } from '@ami/react/core';
import InclusiveMosaicLeadTime from './InclusiveMosaicLeadTime';
import { Button } from 'reactstrap';
import QuoteWizardContext from '../../quotes/QuoteWizardContext';

class Component extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    productGroupId: PropTypes.string,
    productGroups: PropTypes.arrayOf(Object),
    couplerParNumberMade: PropTypes.bool.isRequired,
  };
  static contextType = QuoteWizardContext;

  render() {
    const { productGroups, productGroupId, couplerParNumberMade, onChange } =
      this.props;
    const mapped = productGroups.map(
      (x) =>
        new ImageMosaicDto({
          id: x.id,
          label: x.name,
          imageUrl: x.imageUrl,
          selected: x.id === productGroupId,
          disabled: x.restrictedBasedOnCouplerSelection,
          description: x.restrictedBasedOnCouplerSelection ? (
            <em className="restricted-item">
              <i className="fa fa-exclamation-circle"></i> Not available{' '}
              {`${couplerParNumberMade
                  ? 'for selected lugging'
                  : 'until lugging selected'
                }`}
            </em>
          ) : null,
          extraInformation: x.lowestLeadTime ? (
            <InclusiveMosaicLeadTime leadTime={x.lowestLeadTime} />
          ) : null,
        })
    );
    return (
      <div className="row my-4">
        <MosaicWall title="What Type of Attachment?">
          {!couplerParNumberMade &&
            productGroups.find(
              (x) => x.restrictedBasedOnCouplerSelection
            ) && (
              <div className="row ">
                <div className="col w-100 justify-content-center">
                  <div className="alert alert-warning text-center">
                    <div className="text-danger">
                      Some of these products cannot be configured until a
                      lugging selection has been made
                    </div>
                    <div>
                      <Button
                        color="secondary"
                        className="m-1"
                        onClick={() => this.context.goBackToStep2()}
                      >
                        Back to Step 2
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          {_.sortBy(mapped, (x) => x.disabled).map((x) => (
            <ImageMosaic
              key={x.id}
              data={x}
              onClick={() => onChange(x.id)}
              customClassName={x.extraInformation ? 'hasBestLeadTime' : ''}
              disabled={x.disabled}
            />
          ))}
          {mapped.length === 0 && (
            <Alert color="warning" className="text-center">
              <i className="fa fa-exclamation-circle fa-lg text-danger" /> No
              attachments were found for the selected category
            </Alert>
          )}
        </MosaicWall>
      </div>
    );
  }
}

const ProductGroupSelectionComponent = makeConcealable(Component);
export { ProductGroupSelectionComponent };
